(function () {
  'use strict';

  var cfg = window.gdPopupConfig || {};
  var SK  = 'gd_popup_shown';

  function q(id) { return document.getElementById(id); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  function init() {
    var overlay   = q('gdp-overlay');
    var screen1   = q('gdp-screen1');
    var screen2   = q('gdp-screen2');
    var closeBtn  = q('gdp-close');
    var form      = q('gdp-form');
    var emailEl   = q('gdp-email');
    var dismiss   = q('gdp-dismiss');
    var floatWrap = q('gdp-float-wrap');
    var copyBtn   = q('gdp-copy');
    var useCode   = q('gdp-use-code');
    var codeEl    = q('gdp-code');

    if (!overlay) return;

    /* ── helpers ─────────────────────────────────────── */
    function showScreen(n) {
      if (screen1) screen1.style.display = n === 1 ? '' : 'none';
      if (screen2) screen2.style.display = n === 2 ? '' : 'none';
    }

    function openPopup() {
      showScreen(1);
      overlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      if (floatWrap) floatWrap.style.display = 'none';
    }

    function closePopup() {
      overlay.style.display = 'none';
      document.body.style.overflow = '';
      if (cfg.showOnce !== false) localStorage.setItem(SK, '1');
      if (cfg.showFloating !== false && floatWrap) floatWrap.style.display = 'flex';
    }

    /* ══════════════════════════════════════════════════
       TOUS les bindings ICI — avant tout early return
       ══════════════════════════════════════════════════ */

    /* fermeture */
    on(closeBtn, 'click', closePopup);
    on(dismiss,  'click', function (e) { e.preventDefault(); closePopup(); });
    on(overlay,  'click', function (e) { if (e.target === overlay) closePopup(); });
    on(useCode,  'click', function (e) { e.preventDefault(); closePopup(); });

    /* bouton flottant */
    on(floatWrap, 'click', function () {
      localStorage.removeItem(SK);
      if (floatWrap) floatWrap.style.display = 'none';
      openPopup();
    });
    on(floatWrap, 'keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); floatWrap.click(); }
    });

    /* formulaire email */
    on(form, 'submit', function (e) {
      e.preventDefault();
      var email = emailEl ? emailEl.value.trim() : '';
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (emailEl) { emailEl.focus(); emailEl.style.borderColor = '#e74c3c'; }
        return;
      }
      if (emailEl) emailEl.style.borderColor = '';
      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          'form_type': 'customer',
          'utf8': String.fromCharCode(10003),
          'contact[email]': email,
          'contact[tags]': 'popup-email, grenier-dore'
        })
      })
      .then(function ()  { showScreen(2); })
      .catch(function () { showScreen(2); });
    });

    /* copier le code */
    on(copyBtn, 'click', function () {
      var code = codeEl ? codeEl.textContent.trim() : '';
      if (!code) return;
      var orig = copyBtn.textContent;
      function done() {
        copyBtn.textContent = String.fromCharCode(10003) + ' Copié !';
        setTimeout(function () { copyBtn.textContent = orig; }, 2000);
      }
      function fb() {
        var ta = document.createElement('textarea');
        ta.value = code;
        ta.style.cssText = 'position:fixed;left:-9999px;opacity:0;';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch (_) {}
        document.body.removeChild(ta); done();
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(fb);
      } else { fb(); }
    });

    /* ══════════════════════════════════════════════════
       Check localStorage — APRÈS tous les bindings.
       Si déjà vu : on montre juste le bouton flottant
       et on sort (pas d'auto-open).
       ══════════════════════════════════════════════════ */
    if (cfg.showOnce !== false && localStorage.getItem(SK)) {
      if (cfg.showFloating !== false && floatWrap) floatWrap.style.display = 'flex';
      return;
    }

    /* ── auto-open après délai (première visite) ────── */
    var delay = (cfg.delay != null) ? cfg.delay : 7000;
    setTimeout(openPopup, delay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();